<div class="modal fade" bsModal #FinalizePaymentPackageModal="bs-modal" [config]="{backdrop: 'static'}"
     tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <ws-modal-wrapper headerLabel="Finalize Payment Package"
                              [acceptLabel]="addButtonLabel"
                              [loading]="loading"
                              [disableSave]="tooManyOutputsError"
                              (save)="save()"
                              (cancel)="close()">
                <div style="text-align: center;">
                    @if (!loading) {
                        @if (!tooManyOutputsError) {
                            <label style="text-align: center;">
                                Confirm output type:
                                <select name="outputType" [(ngModel)]="selectedOutputType" (ngModelChange)="selectedOutputChanged($event)">
                                    @for (option of outputTypeOptions; track option) {
                                        <option [value]="option.outputType">
                                            {{ option.label }}
                                        </option>
                                    }
                                </select>
                            </label>
                        }
                        @if (tooManyOutputsError) {
                            <div>
                                <h3 style="text-align: center">
                                    Too many output types selected
                                </h3>
                                <p style="text-align: center; margin-top: 5px;">
                                    Please select payment packages with only one output type
                                </p>
                            </div>
                        }
                    }
                </div>
            </ws-modal-wrapper>
        </div>
    </div>
</div>
